export const createOrderIndependentQueryKey = (queryKey: Record<string, null | number | string | string[]>) => {
  return Object.fromEntries(
    Object.entries(queryKey).map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, Object.fromEntries(value.map((subKey) => [subKey, true]))];
      }
      return [key, value];
    }),
  );
};
